/**
 * StatusExplained — wraps a status pill or badge in a hover explanation of what that status
 * means for this kind of record (P47, Pedro 2026-10-16: tables, then "outside tables as
 * well"). The wording lives in utils/statusHelp.ts, so every place a status shows says the
 * same thing. `extra` adds a line below the meaning (e.g. how to change the status), so a
 * pill never carries two competing tooltips. Renders the child alone when there is no text.
 */
import { Tooltip } from '@mantine/core';
import type * as React from 'react';

import { statusHelp, type StatusHelpEntity } from '../utils/statusHelp';

export function StatusExplained({
  entity, status, extra, children,
}: {
  entity: StatusHelpEntity; status: string; extra?: string; children: React.ReactElement;
}) {
  const meaning = statusHelp(entity, status);
  const text = [meaning, extra].filter(Boolean).join('\n\n');
  if (!text) return children;
  return (
    <Tooltip label={text} withArrow multiline w={300} openDelay={300}
      styles={{ tooltip: { whiteSpace: 'pre-line' } }}>
      <span style={{ display: 'inline-block' }}>{children}</span>
    </Tooltip>
  );
}
